import React from 'react';
import { cn } from '@/lib/utils';

export const ScoreGauge = ({ score, label, className }) => {
  const percentage = Math.round(score * 100);
  const color = score >= 0.7 ? 'text-emerald-600' : score >= 0.4 ? 'text-amber-600' : 'text-rose-600';
  const bgColor = score >= 0.7 ? 'bg-emerald-500' : score >= 0.4 ? 'bg-amber-500' : 'bg-rose-500';
  
  return (
    <div className={cn('flex flex-col items-center', className)}>
      <div className="relative w-16 h-16">
        <svg className="w-full h-full transform -rotate-90">
          <circle
            cx="32"
            cy="32"
            r="28"
            stroke="currentColor"
            strokeWidth="6"
            fill="none"
            className="text-slate-100"
          />
          <circle
            cx="32"
            cy="32"
            r="28"
            stroke="currentColor"
            strokeWidth="6"
            fill="none"
            strokeDasharray={`${percentage * 1.76} 176`}
            className={bgColor.replace('bg-', 'text-')}
            strokeLinecap="round"
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className={cn('text-lg font-bold', color)}>{percentage}%</span>
        </div>
      </div>
      {label && <p className="mt-2 text-xs text-slate-500 text-center">{label}</p>}
    </div>
  );
};

export default ScoreGauge;
